import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-empty-message',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './empty-message.component.html',
  styleUrl: './empty-message.component.scss',
})
export class EmptyMessageComponent {
  icon = input<string>('pi-inbox');
  title = input<string>();
  description = input<string>();
  iconSize = input<string>('text-6xl');
}
